export default "__VITE_ASSET__BOIlakCJ__"